import { useNavigate } from "react-router-dom";
import { useClearAllQueryCache } from "../../../common/infrastructure/hooks/useApiQuery";
import { useAppContext } from "../../../AppContext";
import { useEffect } from "react";
import { routePaths } from "../../../common/infrastructure/routes/routePaths";
export const Logout = () => {
  const navigate = useNavigate();
  const { logout, currentUser } = useAppContext();
  const { clearCache } = useClearAllQueryCache();

  useEffect(() => {
    clearCache();
    logout();
    navigate(routePaths.portalAppointment);
  });

  return <></>;
};
